import type { SchemaLoanRequestResolver_Get } from 'cpool-tables/backend-resolvers';

// leads may be created without haushalt.ausgaben
export const toExpensesFormValues = (ausgaben: SchemaLoanRequestResolver_Get['haushalt']['ausgaben']) => ({
    mietausgaben: ausgaben?.mietausgaben ?? [],
    privateKrankenversicherungen: ausgaben?.privateKrankenversicherungen ?? [],
    sonstigeAusgaben: ausgaben?.sonstigeAusgaben ?? [],
    unterhaltsverpflichtungen: ausgaben?.unterhaltsverpflichtungen ?? [],
});
